import React, { useEffect, useRef } from 'react';

const PUBLIC_URL = process.env.PUBLIC_URL;

const Footer = ({ menuLayout }) => {
  const ref = useRef(null);

  // Measure the footer's rendered height into --footer-h so the layout
  // (content-wrapper min-height, chart/table bands, footer-fixed padding)
  // always reserves the right amount of space, even as the footer reflows.
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let rafId = null;
    const update = () => {
      if (rafId) return;                 // coalesce bursts into one write
      rafId = requestAnimationFrame(() => {
        rafId = null;
        document.documentElement.style.setProperty("--footer-h", `${el.offsetHeight}px`);
      });
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    el.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", update, { once: true });
    });

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <footer ref={ref} className="main-footer footer-flex">
      <div className="footer-disclaimer">
        {menuLayout.footerDisclaimer}
      </div>

      <div className="footer-logos">
        <a
          href="https://mininfra.gov.ua/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/dream_Ministry_for_restoration_2.png`}
            alt="Ministry for Restoration"
            height="24"
          />
        </a>
        <a
          href="https://restoration.gov.ua/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/dream_Restoration_agency_2.png`}
            alt="Restoration Agency"
            height="24"
          />
        </a>
        <a
          href="https://dream.gov.ua/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/Logo DREAM_Yell&Black_Horizontal.svg`}
            alt="DREAM"
            height="24"
          />
        </a>
        <a
          href="https://www.unodc.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/Norway-logo.png`}
            alt="Norway"
            height="24"
          />
        </a>
        <a
          href="https://www.gov.uk/government/organisations/department-for-international-development"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/dream_UK_international_development_3.png`}
            alt="UK International Development"
            height="24"
          />
        </a>
        <a
          href="https://www.eurasia.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/EF_logo-horizontal-b.png`}
            alt="Eurasia Foundation"
            height="24"
          />
        </a>
        <a
          href="https://www.open-contracting.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/dream_OCP.png`}
            alt="Open Contracting Partnership"
            height="24"
          />
        </a>
        <a
          href="https://www.rbcgrp.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="footer-logo"
            src={`${PUBLIC_URL}/logos/RBCGroup_logo_resize.png`}
            alt="RBC Group"
            height="24"
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;